import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isMobileOnly } from 'react-device-detect';

/* Styled Components */
import { Container, Header } from 'styles/signup/BlueSignupHeader';

/* Child Components */
import WishLocalLogo from 'components/common/WishLocalLogo';
import ProgressBar from 'components/common/ProgressBar';

/* Routes */
import { LANDING_PAGE_ROUTE } from 'constants/RouteConstants';

type PropsType = {
  stepsCompleted: number | undefined;
  totalSteps: number;
  showProgressBar: boolean;
  shouldOpenNewTab?: boolean;
};

const SignupHeader = ({
  stepsCompleted,
  totalSteps,
  showProgressBar,
  shouldOpenNewTab,
}: PropsType) => (
  <Header shouldRenderMobile={isMobileOnly}>
    <Container shouldRenderMobile={isMobileOnly}>
      {shouldOpenNewTab ? (
        <a href={LANDING_PAGE_ROUTE} rel="noopener noreferrer" target="_blank">
          <WishLocalLogo />
        </a>
      ) : (
        <Link to={LANDING_PAGE_ROUTE}>
          <WishLocalLogo />
        </Link>
      )}
      {showProgressBar && stepsCompleted !== undefined && (
        <ProgressBar
          stepsCompleted={stepsCompleted}
          totalSteps={totalSteps}
          overrideNumberStyle={!isMobileOnly ? { fontSize: '16px' } : {}}
        />
      )}
    </Container>
  </Header>
);

export default connect()(SignupHeader);
